import { gql } from '@apollo/client'

export const GET_USER_TAG_FOLLOWS = gql`
  query {
    getUserTagFollows {
      id
      user_id
      tag_id
    }
  }
`
